/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FleetYards.net Command API
 * OpenAPI spec version: v1
 */
import {
  useMutation,
  useQuery
} from '@tanstack/vue-query';
import type {
  DataTag,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationReturnType,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query';

import {
  computed,
  toValue,
  unref
} from 'vue';
import type {
  MaybeRefOrGetter
} from 'vue';

import type {
  AdminHardpoint,
  AdminHardpointInput,
  AdminHardpoints,
  ListHardpointsParams,
  SchemaValidationErrorResponse,
  ValidationError
} from '../../models';

import { axiosClient } from '../../../axiosAdminClient.ts';
import type { ErrorType } from '../../../axiosAdminClient.ts';




/**
 * @summary Hardpoints
 */
export const listHardpoints = (
    params?: MaybeRefOrGetter<ListHardpointsParams>,
 signal?: AbortSignal
) => {
      params = toValue(params);

      return axiosClient<AdminHardpoints>(
      {url: `/hardpoints`, method: 'GET',
        params, signal
    },
      );
    }




export const getListHardpointsQueryKey = (params?: MaybeRefOrGetter<ListHardpointsParams>,) => {
    return [
    'hardpoints', ...(params ? [params] : [])
    ] as const;
    }


export const getListHardpointsQueryOptions = <TData = Awaited<ReturnType<typeof listHardpoints>>, TError = ErrorType<SchemaValidationErrorResponse>>(params?: MaybeRefOrGetter<ListHardpointsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listHardpoints>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getListHardpointsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listHardpoints>>> = ({ signal }) => listHardpoints(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listHardpoints>>, TError, TData>
}

export type ListHardpointsQueryResult = NonNullable<Awaited<ReturnType<typeof listHardpoints>>>
export type ListHardpointsQueryError = ErrorType<SchemaValidationErrorResponse>


/**
 * @summary Hardpoints
 */

export function useListHardpoints<TData = Awaited<ReturnType<typeof listHardpoints>>, TError = ErrorType<SchemaValidationErrorResponse>>(
 params?: MaybeRefOrGetter<ListHardpointsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listHardpoints>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListHardpointsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Create Hardpoint
 */
export const createHardpoint = (
    adminHardpointInput: MaybeRefOrGetter<AdminHardpointInput>,
 signal?: AbortSignal
) => {
      adminHardpointInput = toValue(adminHardpointInput);

      return axiosClient<AdminHardpoint>(
      {url: `/hardpoints`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: adminHardpointInput, signal
    },
      );
    }




export const getCreateHardpointMutationKey = () => ['createHardpoint'] as const;

export const getCreateHardpointMutationOptions = <TError = ErrorType<ValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createHardpoint>>, TError,CreateHardpointMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createHardpoint>>, TError,CreateHardpointMutationVariables, TContext> => {

const mutationKey = getCreateHardpointMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createHardpoint>>, CreateHardpointMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  createHardpoint(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateHardpointMutationResult = NonNullable<Awaited<ReturnType<typeof createHardpoint>>>
    export type CreateHardpointMutationBody = AdminHardpointInput
    export type CreateHardpointMutationError = ErrorType<ValidationError>
    export type CreateHardpointMutationVariables = {data: AdminHardpointInput}

    /**
 * @summary Create Hardpoint
 */
export const useCreateHardpoint = <TError = ErrorType<ValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createHardpoint>>, TError,CreateHardpointMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof createHardpoint>>,
        TError,
        CreateHardpointMutationVariables,
        TContext
      > => {
      return useMutation(getCreateHardpointMutationOptions(options), queryClient);
    }
    /**
 * @summary Hardpoint
 */
export const hardpoint = (
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      id = toValue(id);

      return axiosClient<AdminHardpoint>(
      {url: `/hardpoints/${id}`, method: 'GET', signal
    },
      );
    }




export const getHardpointQueryKey = (id: MaybeRefOrGetter<string>,) => {
    return [
    'hardpoints',id
    ] as const;
    }


export const getHardpointQueryOptions = <TData = Awaited<ReturnType<typeof hardpoint>>, TError = ErrorType<SchemaValidationErrorResponse>>(id: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hardpoint>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getHardpointQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof hardpoint>>> = ({ signal }) => hardpoint(id, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(id) !== null && toValue(id) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof hardpoint>>, TError, TData>
}

export type HardpointQueryResult = NonNullable<Awaited<ReturnType<typeof hardpoint>>>
export type HardpointQueryError = ErrorType<SchemaValidationErrorResponse>


/**
 * @summary Hardpoint
 */

export function useHardpoint<TData = Awaited<ReturnType<typeof hardpoint>>, TError = ErrorType<SchemaValidationErrorResponse>>(
 id: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hardpoint>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getHardpointQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Update Hardpoint
 */
export const updateHardpoint = (
    id: MaybeRefOrGetter<string>,
    adminHardpointInput: MaybeRefOrGetter<AdminHardpointInput>,
 signal?: AbortSignal
) => {
      id = toValue(id);
adminHardpointInput = toValue(adminHardpointInput);

      return axiosClient<AdminHardpoint>(
      {url: `/hardpoints/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: adminHardpointInput, signal
    },
      );
    }




export const getUpdateHardpointMutationKey = () => ['updateHardpoint'] as const;

export const getUpdateHardpointMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateHardpoint>>, TError,UpdateHardpointMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateHardpoint>>, TError,UpdateHardpointMutationVariables, TContext> => {

const mutationKey = getUpdateHardpointMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateHardpoint>>, UpdateHardpointMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  updateHardpoint(id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateHardpointMutationResult = NonNullable<Awaited<ReturnType<typeof updateHardpoint>>>
    export type UpdateHardpointMutationBody = AdminHardpointInput
    export type UpdateHardpointMutationError = ErrorType<SchemaValidationErrorResponse>
    export type UpdateHardpointMutationVariables = {id: string;data: AdminHardpointInput}

    /**
 * @summary Update Hardpoint
 */
export const useUpdateHardpoint = <TError = ErrorType<SchemaValidationErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateHardpoint>>, TError,UpdateHardpointMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof updateHardpoint>>,
        TError,
        UpdateHardpointMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateHardpointMutationOptions(options), queryClient);
    }
    /**
 * @summary Destroy Hardpoint
 */
export const destroyHardpoint = (
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      id = toValue(id);

      return axiosClient<void>(
      {url: `/hardpoints/${id}`, method: 'DELETE', signal
    },
      );
    }




export const getDestroyHardpointMutationKey = () => ['destroyHardpoint'] as const;

export const getDestroyHardpointMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof destroyHardpoint>>, TError,DestroyHardpointMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof destroyHardpoint>>, TError,DestroyHardpointMutationVariables, TContext> => {

const mutationKey = getDestroyHardpointMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof destroyHardpoint>>, DestroyHardpointMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  destroyHardpoint(id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DestroyHardpointMutationResult = NonNullable<Awaited<ReturnType<typeof destroyHardpoint>>>

    export type DestroyHardpointMutationError = ErrorType<SchemaValidationErrorResponse>
    export type DestroyHardpointMutationVariables = {id: string}

    /**
 * @summary Destroy Hardpoint
 */
export const useDestroyHardpoint = <TError = ErrorType<SchemaValidationErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof destroyHardpoint>>, TError,DestroyHardpointMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof destroyHardpoint>>,
        TError,
        DestroyHardpointMutationVariables,
        TContext
      > => {
      return useMutation(getDestroyHardpointMutationOptions(options), queryClient);
    }
